import { PaginatedAgentsPayload } from 'app/modules/agents/requests';
import { useQuery } from '@tanstack/react-query';
import { AGENT_QUERY_KEYS } from 'app/modules/agents/queries/keys';
import { post } from 'app/shared/utils/fetchr';
import { PaginatedAgentsResponse } from 'app/modules/agents/responses';

export const useGetAgents = (payload: PaginatedAgentsPayload) => {
  return useQuery({
    enabled: payload.limit > 0,
    queryFn: () =>
      post<PaginatedAgentsResponse>('/v1/agents/paginated', payload),
    queryKey: AGENT_QUERY_KEYS.getAgents(payload),
  });
};
